//@flow
import * as React from 'react';

import ClientDataFetcher from './ClientDataFetcher';
import ProviderDataFetcherWrap from './ProviderDataFetcherWrap';
import TranslationsFetcher from 'common/components/TranslationsFetcher';
import BusinessUnitSelector from './BusinessUnitSelector';
import PrefetchData from './PrefetchData';

import {
    PlatformSettingsFetcher,
    PlatformSettingsPrefetcher
} from 'common/modules/platform-settings';

import {
    MinimalClientFetcher,
    MinimalClientPrefetcher
} from 'common/modules/minimal-client-settings';

import { LocaleConfigFetcher } from 'container/modules/LocaleConfigFetcher';

const InitialDataFetcher = ({
    children
}: {
    children: React.Node
}): React.Node => {
    return (
        <>
            <ClientDataFetcher>
                <MinimalClientFetcher>
                    <BusinessUnitSelector>
                        <TranslationsFetcher>
                            <PlatformSettingsFetcher>
                                <LocaleConfigFetcher>
                                    <ProviderDataFetcherWrap>
                                        {children}
                                    </ProviderDataFetcherWrap>
                                </LocaleConfigFetcher>
                            </PlatformSettingsFetcher>
                        </TranslationsFetcher>
                        <PlatformSettingsPrefetcher />
                    </BusinessUnitSelector>
                </MinimalClientFetcher>
            </ClientDataFetcher>
            <MinimalClientPrefetcher />
            <PrefetchData />
        </>
    );
};

export default InitialDataFetcher;
export { InitialDataFetcher };
